import WeaTable from './components/Table'
import store from './stores/index'
import tableStore from './stores/table'

module.exports = {
	store,
	WeaTable,
	tableStore
}



// WEBPACK FOOTER //
// ./comMobx/wea-table/index.js